import { useMutation, UseMutationResult } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { carrotClient } from "#/utils/CarrotClient"

export interface FreedomFertilityConsentPayload {
  optIn: boolean
}

export function useSubmitFreedomFertilityConsent(): UseMutationResult<
  void,
  ResponseError,
  FreedomFertilityConsentPayload
> {
  return useMutation<void, ResponseError, FreedomFertilityConsentPayload>(
    (payload: FreedomFertilityConsentPayload) => {
      return carrotClient.submitFreedomFertilityConsent(payload)
    },
    {
      retry: buildCarrotApiRetryPolicy(2)
    }
  )
}
